"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plZones = void 0;
var plZones = exports.plZones = [{
  id: 'VARSOVIE',
  name: 'Varsovie',
  country: 'PL',
  cornerNW: {
    latitude: 52.3679,
    longitude: 20.8513
  },
  cornerSE: {
    latitude: 52.0978,
    longitude: 21.2714
  },
  subZones: [{
    name: 'Warszawa Centrum',
    zipcodes: {
      '00-001': {
        label: '00-001'
      }
    }
  }, {
    name: 'Warszawa Śródmieście',
    zipcodes: {
      '00-110': {
        label: '00-110'
      }
    }
  }, {
    name: 'Warszawa Żoliborz',
    zipcodes: {
      '01-001': {
        label: '01-001'
      }
    }
  }, {
    name: 'Warszawa Mokotów',
    zipcodes: {
      '02-001': {
        label: '02-001'
      }
    }
  }, {
    name: 'Warszawa Praga Północ',
    zipcodes: {
      '03-001': {
        label: '03-001'
      }
    }
  }, {
    name: 'Warszawa Wawer',
    zipcodes: {
      '04-001': {
        label: '04-001'
      }
    }
  }, {
    name: 'Warszawa Wesoła',
    zipcodes: {
      '05-077': {
        label: '05-077'
      }
    }
  }]
}];